import React from 'react';

import { useIntl } from 'react-intl';

import RepeatIcon from '@atlaskit/icon-lab/core/repeat';

import { Expand, ExpandList } from '../../../../../../../common/ui/expand-list';
import { LinkedResults } from '../../../../../../../common/ui/linked-results';

import { messages } from './messages';
import type { LinkedResult, VideoResultRendererProps } from './shared/types';

type PastMeetingsProps = {
	data: VideoResultRendererProps['data'];
	linkedResults: LinkedResult[];
	thirdPartyConfigs: VideoResultRendererProps['thirdPartyConfigs'];
	onResultClicked: VideoResultRendererProps['onResultClicked'];
	onResultContextMenu?: VideoResultRendererProps['onResultContextMenu'];
	position?: number;
	defaultExpandedIndex?: number;
};

/**
 * Expandable "Past meetings" footer for MS Teams meeting transcript search results.
 * Shows recurring past occurrences using the shared ExpandList/Expand + LinkedResults pattern,
 * consistent with how search-graph-message handles linked results via MentionedByLinkedResults.
 */
export const PastMeetings = ({
	data,
	linkedResults,
	thirdPartyConfigs,
	onResultClicked,
	onResultContextMenu,
	position,
	defaultExpandedIndex,
}: PastMeetingsProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (!linkedResults || linkedResults.length === 0) {
		return null;
	}

	return (
		<ExpandList parentPosition={position} defaultExpandedIndex={defaultExpandedIndex}>
			<Expand
				icon={RepeatIcon}
				attachmentCount={linkedResults.length}
				attachmentType="url"
				label={formatMessage(messages.pastMeetings)}
			>
				<LinkedResults
					url={data.url}
					title={data.title}
					linkedResults={linkedResults}
					thirdPartyConfigs={thirdPartyConfigs}
					onResultClicked={onResultClicked}
					onResultContextMenu={onResultContextMenu}
					fallbackType="video"
					description=""
					icon={<></>}
				/>
			</Expand>
		</ExpandList>
	);
};
